import React from 'react';
import * as Icon from 'react-feather';

export const SidebarData = [
  {
    label: "Main",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    permission: "view-dashboard",
    submenuItems: [
      {
        label: "Dashboard",
        icon: <Icon.Grid />,
        submenu: true,
        showSubRoute: false,
        permission: "view-dashboard",
        submenuItems: [
          {
            label: "Admin Dashboard",
            link: "/",
            permission: "view-dashboard"
          }
        ]
      }
    ]
  },
  {
    label: "Manufacturing",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Manufacturing",
    permission: "view-manufacturing",
    submenuItems: [
      {
        label: "Manufacturing Dashboard",  // NEW - Add this as first item
        link: "/manufacturing/dashboard",
        icon: <Icon.Home />,
        permission: "view-manufacturing"
      },
      {
        label: "Raw Material Product Entry",  // NEW - Create/Manage raw materials
        link: "/manufacturing/raw-material-master",
        icon: <Icon.Database />,
        permission: "manage-raw-materials"
      },
      {
        label: "Raw Material Purchase",  // NEW - First step
        link: "/manufacturing/raw-material-purchase",
        icon: <Icon.ShoppingCart />,
        permission: "create-raw-material-purchase"
      },
      // {
      //   label: "Raw Material Dispatch",
      //   link: "/manufacturing/dispatch",
      //   icon: <Icon.Truck />,
      //   permission: "create-dispatch"
      // },
      // {
      //   label: "Raw Material Receive",
      //   link: "/manufacturing/receive",
      //   icon: <Icon.Download />,
      //   permission: "view-receive"
      // },
      {
        label: "Manufacturing Stock",
        link: "/manufacturing/stock",
        icon: <Icon.Package />,
        permission: "view-manufacturing-stock"
      },
      {
        label: "Production Entry",
        link: "/manufacturing/production",
        icon: <Icon.Settings />,
        permission: "create-production"
      },
      {
        label: "Production History",
        link: "/manufacturing/history",
        icon: <Icon.Clock />,
        permission: "view-production"
      },
      // {
      //   label: "Stock Transfer",
      //   link: "/manufacturing/transfer",
      //   icon: <Icon.Shuffle />,
      //   permission: "manage-stock-transfer"
      // },
      {
        label: "Waste Entry",
        link: "/manufacturing/waste",
        icon: <Icon.Trash2 />,
        permission: "create-waste"
      },
      // {
      //   label: "Convert to Purchase",
      //   link: "/manufacturing/convert",
      //   icon: <Icon.ShoppingBag />,
      //   permission: "convert-production"
      // },
      {
        label: "Manufacturing Reports",
        link: "/manufacturing/reports",
        icon: <Icon.BarChart2 />,
        permission: "view-manufacturing-reports"
      }

    ]
  },
  {
    label: "Inventory",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",
    permission: "view-products",
    submenuItems: [
      {
        label: "Products",
        link: "/product-list",
        icon: <Icon.Box />,
        showSubRoute: false,
        submenu: false,
        permission: "view-products"
      },
      {
        label: "Category",
        link: "/category-list",
        icon: <Icon.Codepen />,
        showSubRoute: false,
        submenu: false,
        permission: "view-categories"
      },
      {
        label: "Brands",
        link: "/brand-list",
        icon: <Icon.Tag />,
        showSubRoute: false,
        submenu: false,
        permission: "view-brands"
      },
      {
        label: "Units",
        link: "/units",
        icon: <Icon.Speaker />,
        showSubRoute: false,
        submenu: false,
        permission: "view-units"
      },
      {
        label: "Tax",
        link: "/tax",
        icon: <Icon.DollarSign />,
        showSubRoute: false,
        submenu: false,
        permission: "view-tax"
      },
      {
        label: "Barcode",
        link: "/print-barcode",
        icon: <Icon.BarChart2 />,
        showSubRoute: false,
        submenu: false,
        permission: "view-barcodes"
      }
    ]
  },
  {
    label: "Purchases",
    submenuOpen: true,
    submenuHdr: "Purchases",
    showSubRoute: false,
    permission: "view-purchases",
    submenuItems: [
      {
        label: "Purchases",
        link: "/purchase-list",
        icon: <Icon.ShoppingBag />,
        showSubRoute: false,
        submenu: false,
        permission: "view-purchases"
      },
      {
        label: "Purchase Order",
        link: "/purchase-order-report",
        icon: <Icon.FileMinus />,
        showSubRoute: false,
        submenu: false,
        permission: "view-purchases"
      },
      {
        label: "Purchase Return",
        link: "/purchase-returns",
        icon: <Icon.RefreshCw />,
        showSubRoute: false,
        submenu: false,
        permission: "view-purchase-returns"
      },
      {
        label: "Purchase Invoice",
        link: "/purchase-order-invoice",
        icon: <Icon.File />,
        showSubRoute: false,
        submenu: false,
        permission: "view-purchases"
      }
    ]
  },
  {
    label: "Stock",
    submenuOpen: true,
    submenuHdr: "Stock",
    submenu: true,
    showSubRoute: false,
    permission: "view-products",
    submenuItems: [
      {
        label: "Manage Stock",
        link: "/manage-stocks",
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
        permission: "view-stock"
      },
      // {
      //   label: "Stock Movements",
      //   link: "/stock-movements",
      //   icon: <Icon.Activity />,
      //   showSubRoute: false,
      //   submenu: false,
      //   permission: "view-stock-movements"
      // },
      // {
      //   label: "Low Stock Alert",
      //   link: "/low-stock-alert",
      //   icon: <Icon.AlertTriangle />,
      //   showSubRoute: false,
      //   submenu: false,
      //   permission: "view-stock-alert"
      // }
    ]
  },
  {
    label: "Sales",
    submenuOpen: true,
    submenuHdr: "Sales",
    submenu: false,
    showSubRoute: false,
    permission: "view-sales",
    submenuItems: [
      {
        label: "Sales",
        link: "/sales-list",
        icon: <Icon.ShoppingCart />,
        showSubRoute: false,
        submenu: false,
        permission: "view-sales"
      },
      {
        label: "Invoices",
        link: "/sales-invoices",
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false,
        permission: "view-invoices"
      },
      {
        label: "Sales Return",
        link: "/sales-returns",
        icon: <Icon.Copy />,
        showSubRoute: false,
        submenu: false,
        permission: "view-sales-returns"
      },
      {
        label: "Quotation",
        link: "/quotation-list",
        icon: <Icon.Save />,
        showSubRoute: false,
        submenu: false,
        permission: "view-quotations"
      }
    ]
  },
  {
    label: "Finance & Accounts",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Finance & Accounts",
    permission: "view-expenses",
    submenuItems: [
      {
        label: "Expenses",
        submenu: true,
        showSubRoute: false,
        icon: <Icon.FileText />,
        permission: "view-expenses",
        submenuItems: [
          {
            label: "Expenses",
            link: "/expense-list",
            showSubRoute: false,
            permission: "view-expenses"
          },
          {
            label: "Expense Category",
            link: "/expense-category",
            showSubRoute: false,
            permission: "view-expenses"
          }
        ],
      },
      {
        label: "Bank Accounts",
        link: "/bank-accounts",
        icon: <Icon.Book />,
        showSubRoute: false,
        submenu: false,
        permission: "view-bank-accounts"
      },
      {
        label: "Balance Sheet",
        link: "/balance-sheet",
        icon: <Icon.BarChart />,
        showSubRoute: false,
        submenu: false,
        permission: "view-balance-sheet"
      },
      {
        label: "Trial Balance",
        link: "/trial-balance",
        icon: <Icon.Layers />,
        showSubRoute: false,
        submenu: false,
        permission: "view-trial-balance"
      },
      {
        label: "Account Statement",
        link: "/account-statement",
        icon: <Icon.File />,
        showSubRoute: false,
        submenu: false,
        permission: "view-account-statement"
      },
      {
        label: "Opening Balance",
        link: "/opening-balance",
        icon: <Icon.Database />,
        showSubRoute: false,
        submenu: false,
        permission: "view-opening-balances"
      },
      {
        label: "Opening Balance Entry",
        link: "/opening-balance-entry",
        icon: <Icon.PlusCircle />,
        showSubRoute: false,
        submenu: false,
        permission: "create-opening-balances"
      }
    ]
  },
  {
    label: "People",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "People",
    permission: "view-customers",
    submenuItems: [
      {
        label: "Customers",
        link: "/customers",
        icon: <Icon.User />,
        showSubRoute: false,
        submenu: false,
        permission: "view-customers"
      },
      {
        label: "Suppliers",
        link: "/suppliers",
        icon: <Icon.Users />,
        showSubRoute: false,
        submenu: false,
        permission: "view-suppliers"
      }
    ]
  },
  {
    label: "Reports",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Reports",
    permission: "view-reports",
    submenuItems: [
      {
        label: "Sales Report",
        link: "/sales-report",
        icon: <Icon.BarChart2 />,
        showSubRoute: false,
        permission: "view-sales"
      },
      {
        label: "Purchase Report",
        link: "/purchase-report",
        icon: <Icon.PieChart />,
        showSubRoute: false,
        permission: "view-purchases"
      },
      {
        label: "Inventory Report",
        link: "/inventory-report",
        icon: <Icon.Inbox />,
        showSubRoute: false,
        permission: "view-products"
      },
      {
        label: "Supplier Report",
        link: "/supplier-report",
        icon: <Icon.UserCheck />,
        showSubRoute: false,
        permission: "view-suppliers"
      },
      {
        label: "Customer Report",
        link: "/customer-report",
        icon: <Icon.User />,
        showSubRoute: false,
        permission: "view-customers"
      },
      {
        label: "Expense Report",
        link: "/expense-report",
        icon: <Icon.FileText />,
        showSubRoute: false,
        permission: "view-expenses"
      },
      {
        label: "Income Report",
        link: "/income-report",
        icon: <Icon.BarChart />,
        showSubRoute: false,
        permission: "view-sales"
      },
      {
        label: "Tax Report",
        link: "/tax-report",
        icon: <Icon.Database />,
        showSubRoute: false,
        permission: "view-tax-reports"
      },
      {
        label: "Profit & Loss",
        link: "/profit-loss-report",
        icon: <Icon.TrendingDown />,
        showSubRoute: false,
        permission: "view-profit-loss"
      }
    ],
  },
  {
    label: "User Management",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "User Management",
    permission: "view-users",
    submenuItems: [
      {
        label: "Users",
        link: "/users",
        icon: <Icon.UserCheck />,
        showSubRoute: false,
        permission: "view-users"
      },
      {
        label: "Roles & Permissions",
        link: "/roles-permissions",
        icon: <Icon.Shield />,
        showSubRoute: false,
        permission: "view-roles"
      }
    ]
  },
  {
    label: "Pages",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Pages",
    permission: "view-profile",
    submenuItems: [
      {
        label: "Profile",
        link: "/profile",
        icon: <Icon.User />,
        showSubRoute: false,
        permission: "view-profile"
      },
      {
        label: "Company Settings",
        link: "/company-settings",
        icon: <Icon.Settings />,
        showSubRoute: false,
        permission: "view-settings"
      }
    ]
  }
];

// Helper function to filter menu items based on permissions
export const filterMenuByPermissions = (menuItems, userPermissions, isSuperAdmin) => {
  if (isSuperAdmin) return menuItems;

  return menuItems.filter(item => {
    // Check if the main menu item has permission
    if (item.permission && !userPermissions.includes(item.permission)) {
      return false;
    }

    // Filter submenu items if they exist
    if (item.submenuItems && item.submenuItems.length > 0) {
      const filteredSubItems = item.submenuItems.filter(subItem => {
        // For nested submenu items
        if (subItem.submenuItems && subItem.submenuItems.length > 0) {
          const filteredNestedItems = subItem.submenuItems.filter(nestedItem => {
            if (nestedItem.permission && !userPermissions.includes(nestedItem.permission)) {
              return false;
            }
            return true;
          });
          subItem.submenuItems = filteredNestedItems;

          // Keep the parent if it has any visible children
          if (subItem.permission && !userPermissions.includes(subItem.permission)) {
            return filteredNestedItems.length > 0;
          }
          return filteredNestedItems.length > 0;
        }

        // For regular menu items
        if (subItem.permission && !userPermissions.includes(subItem.permission)) {
          return false;
        }
        return true;
      });

      item.submenuItems = filteredSubItems;
      return filteredSubItems.length > 0;
    }

    return true;
  });
};

// Add manufacturing permissions to your permissions list
export const manufacturingPermissions = [
  { name: 'View Manufacturing', slug: 'view-manufacturing', module: 'manufacturing' },
  { name: 'View Manufacturing Stock', slug: 'view-manufacturing-stock', module: 'manufacturing' },
  { name: 'Create Dispatch', slug: 'create-dispatch', module: 'manufacturing' },
  { name: 'View Dispatch', slug: 'view-dispatch', module: 'manufacturing' },
  { name: 'Edit Dispatch', slug: 'edit-dispatch', module: 'manufacturing' },
  { name: 'Delete Dispatch', slug: 'delete-dispatch', module: 'manufacturing' },
  { name: 'Create Receive', slug: 'create-receive', module: 'manufacturing' },
  { name: 'View Receive', slug: 'view-receive', module: 'manufacturing' },
  { name: 'Create Production', slug: 'create-production', module: 'manufacturing' },
  { name: 'View Production', slug: 'view-production', module: 'manufacturing' },
  { name: 'Edit Production', slug: 'edit-production', module: 'manufacturing' },
  { name: 'Delete Production', slug: 'delete-production', module: 'manufacturing' },
  { name: 'Manage Stock Transfer', slug: 'manage-stock-transfer', module: 'manufacturing' },
  { name: 'Create Waste', slug: 'create-waste', module: 'manufacturing' },
  { name: 'View Waste', slug: 'view-waste', module: 'manufacturing' },
  // { name: 'Convert Production', slug: 'convert-production', module: 'manufacturing' },
  { name: 'View Manufacturing Reports', slug: 'view-manufacturing-reports', module: 'manufacturing' }
];

// Add missing permissions for existing modules
export const missingPermissions = [
  // Categories
  { name: 'View Categories', slug: 'view-categories', module: 'categories' },
  { name: 'Create Categories', slug: 'create-categories', module: 'categories' },
  { name: 'Edit Categories', slug: 'edit-categories', module: 'categories' },
  { name: 'Delete Categories', slug: 'delete-categories', module: 'categories' },

  // Brands
  { name: 'View Brands', slug: 'view-brands', module: 'brands' },
  { name: 'Create Brands', slug: 'create-brands', module: 'brands' },
  { name: 'Edit Brands', slug: 'edit-brands', module: 'brands' },
  { name: 'Delete Brands', slug: 'delete-brands', module: 'brands' },

  // Units
  { name: 'View Units', slug: 'view-units', module: 'units' },
  { name: 'Create Units', slug: 'create-units', module: 'units' },
  { name: 'Edit Units', slug: 'edit-units', module: 'units' },
  { name: 'Delete Units', slug: 'delete-units', module: 'units' },

  // Tax
  { name: 'View Tax', slug: 'view-tax', module: 'tax' },
  { name: 'Create Tax', slug: 'create-tax', module: 'tax' },
  { name: 'Edit Tax', slug: 'edit-tax', module: 'tax' },
  { name: 'Delete Tax', slug: 'delete-tax', module: 'tax' },

  // Barcodes
  { name: 'View Barcodes', slug: 'view-barcodes', module: 'barcodes' },
  { name: 'Generate Barcodes', slug: 'generate-barcodes', module: 'barcodes' },
  { name: 'Print Barcodes', slug: 'print-barcodes', module: 'barcodes' },

  // Purchase Returns
  { name: 'View Purchase Returns', slug: 'view-purchase-returns', module: 'purchase-returns' },
  { name: 'Create Purchase Returns', slug: 'create-purchase-returns', module: 'purchase-returns' },
  { name: 'Edit Purchase Returns', slug: 'edit-purchase-returns', module: 'purchase-returns' },
  { name: 'Delete Purchase Returns', slug: 'delete-purchase-returns', module: 'purchase-returns' },

  // Sales Returns
  { name: 'View Sales Returns', slug: 'view-sales-returns', module: 'sales-returns' },
  { name: 'Create Sales Returns', slug: 'create-sales-returns', module: 'sales-returns' },
  { name: 'Edit Sales Returns', slug: 'edit-sales-returns', module: 'sales-returns' },
  { name: 'Delete Sales Returns', slug: 'delete-sales-returns', module: 'sales-returns' },

  // Quotations
  { name: 'View Quotations', slug: 'view-quotations', module: 'sales' },
  { name: 'Create Quotations', slug: 'create-quotations', module: 'sales' },
  { name: 'Edit Quotations', slug: 'edit-quotations', module: 'sales' },
  { name: 'Delete Quotations', slug: 'delete-quotations', module: 'sales' },

  // Invoices
  { name: 'View Invoices', slug: 'view-invoices', module: 'sales' },
  { name: 'Create Invoices', slug: 'create-invoices', module: 'sales' },
  { name: 'Edit Invoices', slug: 'edit-invoices', module: 'sales' },
  { name: 'Delete Invoices', slug: 'delete-invoices', module: 'sales' },
  { name: 'Print Invoices', slug: 'print-invoices', module: 'sales' },

  // Bank Accounts
  { name: 'View Bank Accounts', slug: 'view-bank-accounts', module: 'bank' },
  { name: 'Create Bank Accounts', slug: 'create-bank-accounts', module: 'bank' },
  { name: 'Edit Bank Accounts', slug: 'edit-bank-accounts', module: 'bank' },
  { name: 'Delete Bank Accounts', slug: 'delete-bank-accounts', module: 'bank' },
  { name: 'View Bank Transactions', slug: 'view-bank-transactions', module: 'bank' },

  // Opening Balance
  { name: 'View Opening Balances', slug: 'view-opening-balances', module: 'opening-balance' },
  { name: 'Create Opening Balances', slug: 'create-opening-balances', module: 'opening-balance' },
  { name: 'Edit Opening Balances', slug: 'edit-opening-balances', module: 'opening-balance' },
  { name: 'Delete Opening Balances', slug: 'delete-opening-balances', module: 'opening-balance' },

  // Stock Management
  { name: 'View Stock', slug: 'view-stock', module: 'inventory' },
  { name: 'Adjust Stock', slug: 'adjust-stock', module: 'inventory' },
  { name: 'View Stock Movements', slug: 'view-stock-movements', module: 'inventory' },
  { name: 'View Stock Alert', slug: 'view-stock-alert', module: 'inventory' },

  // Reports
  { name: 'View Reports', slug: 'view-reports', module: 'reports' },
  { name: 'View Balance Sheet', slug: 'view-balance-sheet', module: 'reports' },
  { name: 'View Trial Balance', slug: 'view-trial-balance', module: 'reports' },
  { name: 'View Account Statement', slug: 'view-account-statement', module: 'reports' },
  { name: 'View Tax Reports', slug: 'view-tax-reports', module: 'reports' },
  { name: 'View Profit Loss', slug: 'view-profit-loss', module: 'reports' },

  // Profile and Settings
  { name: 'View Profile', slug: 'view-profile', module: 'profile' },
  { name: 'View Settings', slug: 'view-settings', module: 'settings' }
];